import {stripPostalCodeFromAddress} from "../../places/utils/strip_postal_code_from_address";
import {EXTERNAL_FAVORITE_LIST_CARD_CONTENT} from "../constants/external_favorite_list_card_content";
import {IFavoriteListItemDTO} from "../types/IFavoriteListItemDTO";

export const getExternalFavoriteListCardAddress = (favorite: IFavoriteListItemDTO): string => {
    const location = favorite.location?.trim();

    if (!location) return EXTERNAL_FAVORITE_LIST_CARD_CONTENT.ADDRESS_PLACEHOLDER;

    return stripPostalCodeFromAddress(location);
};

export const getExternalFavoriteListCardSubtitle = (favorite: IFavoriteListItemDTO): string =>
    favorite.name?.trim() || EXTERNAL_FAVORITE_LIST_CARD_CONTENT.SUBTITLE_PLACEHOLDER;

export const parseExternalFavoriteDecimal = (value: string | null): number | null => {
    if (value === null || value === "") return null;

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
};

export const parseExternalFavoriteNumber = (value: number | string | null | undefined): number | null => {
    if (value === null || value === undefined || value === "") return null;

    return parseExternalFavoriteDecimal(String(value));
};
import {stripPostalCodeFromAddress} from "../../places/utils/strip_postal_code_from_address";
import {EXTERNAL_FAVORITE_LIST_CARD_CONTENT} from "../constants/external_favorite_list_card_content";
import {IFavoriteListItemDTO} from "../types/IFavoriteListItemDTO";

export const getExternalFavoriteListCardAddress = (favorite: IFavoriteListItemDTO): string => {
    const location = favorite.location?.trim();

    if (!location) return EXTERNAL_FAVORITE_LIST_CARD_CONTENT.ADDRESS_PLACEHOLDER;

    return stripPostalCodeFromAddress(location);
};

export const getExternalFavoriteListCardSubtitle = (favorite: IFavoriteListItemDTO): string =>
    favorite.name?.trim() || EXTERNAL_FAVORITE_LIST_CARD_CONTENT.SUBTITLE_PLACEHOLDER;

export const parseExternalFavoriteDecimal = (value: string | null): number | null => {
    if (value === null || value === "") return null;

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
};

export const parseExternalFavoriteNumber = (value: number | string | null | undefined): number | null => {
    if (value === null || value === undefined || value === "") return null;

    return parseExternalFavoriteDecimal(String(value));
};
